import { render, staticRenderFns } from "./RegistrationManagement.vue?vue&type=template&id=720b054a"
import script from "./RegistrationManagement.vue?vue&type=script&lang=js"
export * from "./RegistrationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports